module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/stockyana-bkg-65d0bde56cebe199d7cadfd63fe855df.jpg";